var __jsx = React.createElement;
import PageContainer from '@modules/layout/components/shared/container';
import APP_CONFIGURATION from '@lib/app.config';
import PlatformLogo from '@modules/shared/logos/platform-logo';
import React from 'react';
const AuthFormTemplate = _ref => {
  let {
    children
  } = _ref;
  return __jsx(PageContainer, null, __jsx("div", {
    className: "flex flex-col items-center gap-8 w-full md:w-500px"
  }, __jsx("div", {
    className: "header-element header-logo block w-fit"
  }, __jsx(PlatformLogo, {
    height: APP_CONFIGURATION.config.loginPlatformLogoHeight,
    useContrastIcon: APP_CONFIGURATION.config.loginUseContrastIcon
  })), children));
};
export default AuthFormTemplate;